import { computed, Injectable, signal } from '@angular/core';

import { isUsableAccessToken, isUsableEventSource, isUsableJemmaBaseUrl } from '../shared/credentials.util';
import { CreateEntityWidgetConfig } from './create-entity-widget-config.types';

/**
 * Holds one `<wcg-create-entity>` instance's resolved host config so the
 * element's child forms can read it. Provided on `CreateEntityElementComponent`
 * (not root) so several instances on one page never share a token.
 */
@Injectable()
export class CreateEntityConfigService {
    private readonly _config = signal<CreateEntityWidgetConfig>({ accessToken: '', eventSource: '', jemmaBaseUrl: '' });

    readonly $config = this._config.asReadonly();

    /** True only when the token, event source and Jemma URL would all be accepted by `createEntityAuthInterceptor`. */
    readonly $isUsable = computed(() => {
        const _config = this._config();
        return isUsableAccessToken(_config.accessToken) && isUsableEventSource(_config.eventSource) && isUsableJemmaBaseUrl(_config.jemmaBaseUrl);
    });

    setConfig(config: CreateEntityWidgetConfig): void {
        this._config.set(config);
    }
}
